<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加打卡模板')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="success" size="mini" icon="el-icon-info" @click="deleteGroup">删除</el-button>
    </div>
    <!-- 筛选 -->
    <!-- <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="企业名称：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-form-item label="认证状态：" prop="auth">
        <el-select v-model="screenForm.auth" placeholder="不限" clearable>
          <el-option label="审核中" :value="0" />
          <el-option label="认证通过" :value="1" />
          <el-option label="认证失败" :value="2" />
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form> -->
    <!-- 表格 -->
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData2"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="company" label="打卡时间">
          <template slot-scope="scope">
            <div>第1次打卡时间：{{ scope.row.company ? scope.row.company.punchTime1 : '' }}</div>
            <div>第2次打卡时间：{{ scope.row.company ? scope.row.company.punchTime2 : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="company.punchName" label="模板名称" />
        <el-table-column prop="company.punchRange" label="打卡范围(米)" />
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑打卡模板', scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" width="800px" :title="dialogTitle" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :rules="rules" :model="form" label-width="80px">
        <el-form-item prop="locations" label-width="100px" label="打卡地点：">
          <div v-for="(item, index) in form.locations" :key="index">
            <div style="margin-bottom: 20px; display: flex; justify-content: flex-start; align-items: center">
              <div>地点{{ index + 1 }}：</div>
              <el-input
                id="tipinput"
                v-model="item.title"
                placeholder="搜索地名或者地址"
                prefix-icon="el-icon-search"
                style="max-width: 360px"
                @focus="siteIFocus(index)"
                @keyup.native="siteChangeI(item.title)"
              />
              <el-link icon="el-icon-location-outline" style="margin-left: 15px; font-size: 24px" @click="siteLocation(index)" />
              <el-link v-if="index == form.locations.length - 1" icon="el-icon-plus" style="margin-left: 15px; font-size: 24px" @click="AddSite" />
              <el-link
                v-if="index != form.locations.length - 1"
                icon="el-icon-minus"
                style="margin-left: 15px; font-size: 24px"
                @click="minusSite(index)"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width="100px">
          <div style="width: 100%; height: 100%">
            <div class="searchContainer">
              <div
                v-for="(item, index) in list"
                v-show="isshow"
                :key="item.id"
                class="searchItem"
                :style="activeIndex === index && 'background: #ecf5ff'"
                @click.stop="itemChange(item, index)"
              >
                <div>{{ item.name }}</div>
                <div style="color: #999; font-size: 12px">{{ item.address }}</div>
              </div>
            </div>
            <div id="map" class="map-container" style="width: 100%; height: 300px">
              <el-amap class="amap-box" vid="map'amap-vue'" :zoom="zoom" :center="mapCenter" :events="events">
                <el-amap-marker v-if="mapCenter" key="100" :position="mapCenter" />
              </el-amap>
            </div>
            <div style="width: 100%; display: flex; line-height: 40px; margin-top: 15px; justify-content: space-between">
              <div class="flex-center" style="align-self: flex-start">
                <span class="area"> <i v-show="gettingAddress" style="padding: 0 10px" class="el-icon-loading" />已选地址：</span>
              </div>
              <!-- 这个地方获取的是详细的省市区 -->
              <div style="flex: 1; display: flex; flex-wrap: wrap">
                <!-- 省 -->
                <span v-if="form.poiProvince" class="area">{{ form.poiProvince.length && form.poiProvince !== '[]' ? form.poiProvince : '-' }}</span>
                <!-- 市 -->
                <span v-if="form.poiCity" class="area">{{ form.poiCity.length && form.poiCity !== '[]' ? form.poiCity : '-' }}</span>
                <!-- 县或者区 -->
                <span v-if="form.poiDistrict != '[]'" class="area">{{ form.poiDistrict.length && form.poiDistrict !== '[]' ? form.poiDistrict : '-' }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="punchName" label-width="100px" label="模板名称：">
          <el-input v-model="form.punchName" placeholder="请输入模板名称" style="max-width: 200px" />
        </el-form-item>
        <el-form-item prop="punchRange" label-width="100px" label="打卡范围：">
          <el-input v-model="form.punchRange" placeholder="请输入打卡范围" oninput="value=value.replace(/[^0-9.]/g,'')" style="max-width: 200px" />
          <span style="margin-left: 20px">米</span>
        </el-form-item>
        <el-form-item prop="dakaDate" label-width="100px" label="打卡时间：">
          <div>
            <div>
              <span>时间一：</span>
              <el-input v-model="form.dakaDate.punchTime1" style="max-width: 200px" />
            </div>
            <div style="margin-top: 16px">
              <span>时间二：</span>
              <el-input v-model="form.dakaDate.punchTime2" style="max-width: 200px" />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加打卡模板')">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog :visible.sync="previewVideoDialog">
      <video v-if="previewVideoDialog" width="100%" :src="videoUrl" controls autoplay />
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'

export default {
  mixins: [pagination],
  data() {
    const self = this
    return {
      authCount: {
        count: 0,
        loading: true
      },
      tableH: 0,
      videoUrl: '',
      previewVideoDialog: false,
      screenForm: {
        companyName: '',
        auth: null
      },
      tableData: [],
      tableData2: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        locations: [
          {
            title: ''
          }
        ],
        punchName: '',
        punchRange: '',
        dakaDate: {
          punchTime1: '',
          punchTime2: ''
        },
        poiLat: '',
        poiLon: '',
        poiAddress: '',
        poiProvince: '',
        poiCity: '',
        poiDistrict: '',
        mapCenter: ''
      },
      siteLogLat: [
        {
          lon: '',
          lat: ''
        }
      ],
      ids: [], // 批量选中的账号组
      rules: {
        locations: [{ required: true, message: '请选择打卡地点', validator: this.checkExistName, trigger: 'blur' }],
        punchName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        punchRange: [{ required: true, message: '请输入打卡范围', trigger: 'blur' }],
        dakaDate: [{ required: true, message: '请填写打卡时间', validator: this.checkExistDate, trigger: 'blur' }]
      },
      Id: '',
      enterpriseId: '',
      gettingAddress: false,
      isshow: false, // 显示搜索内容
      inputValue: '', // 地图搜索
      siteActive: 0,
      tabIndex: '',
      list: [],
      activeIndex: '',
      zoom: 12,
      searchOption: {
        citylimit: false
      },
      location: '',
      siteDialog: false,
      primitiveData: {}, // 下方不是
      mapCenter: [113, 23],
      events: {
        // 点击获取地址的数据
        click(e) {
          const { lng, lat } = e.lnglat
          self.getAddress(lng, lat)
          console.log(lat, lng)
          self.form.poiLon = lng
          self.form.poiLat = lat
          self.mapCenter = null
          self.mapCenter = [lng, lat]
        }
      }
    }
  },
  computed: {
    introduceImages() {
      return (this.form.introduceImages || []).map((item) => {
        return {
          url: item
        }
      })
    },
    fuliImages() {
      return (this.form.fuliImages || []).map((item) => {
        return {
          url: item
        }
      })
    },
    jiyuImages() {
      return (this.form.jiyuImages || []).map((item) => {
        return {
          url: item
        }
      })
    }
  },
  watch: {
    'form.poiAddress': {
      handler(v) {
        this.form.poiAddress = v === '[]' ? '' : v
      }
    },
    siteDialog(val) {
      if (val) {
        this.inputValue = this.primitiveData.name
        this.list = []
      }
    },
    // 监听输入框是否有值
    inputValue(value) {
      if (value) {
        console.log(value)
        this.form.locations[this.siteActive].title = value
        // 监听输入内容
        this.initMapByInput()
      }
    },
    showDialog(value) {
      if (value) {
        this.inputValue = ''
      }
    }
  },
  mounted() {
    // this.getVerifyCount()
    this.getTableList() // 获取打卡模板列表
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 地图类
    locationSure(val) {
      console.log(val) // 定位地址
      this.location = val.name
      this.primitiveData = val
    },
    itemChange(n, index) {
      const that = this
      that.activeIndex = index
      // 输入后搜索出来的，反地理编码出来的参数有所不同
      const lng = n.lng || n.longitude || n.location.lng
      const lat = n.lat || n.latitude || n.location.lat
      const name = n.name || ''
      console.log(n, '地里位置')
      // that.inputValue = name
      this.getAddress(lng, lat)
      that.zoom = 13
      that.form.poiLat = lat
      that.form.poiLon = lng
      that.isshow = false
    },
    // 自动搜索地点
    initMapByInput() {
      const that = this
      // 自动搜索插件
      AMap.plugin('AMap.Autocomplete', () => {
        const autoOptions = {
          city: '全国'
        }
        const autoComplete = new AMap.Autocomplete(autoOptions)
        // 要修改
        autoComplete.search(that.inputValue, function(status, e) {
          if (status === 'complete' && e.info === 'OK') {
            if (e.tips && e.tips.length > 0) {
              const tips = e.tips.filter((i) => {
                return i.location && i.address.length > 0
              })
              const tip = tips[0]
              that.mapCenter = [tip.location.lng, tip.location.lat]
              that.zoom = 13
              that.list = tips
            } else {
              that.list = []
            }
          }
        })
      })
    },
    // 获取打卡模板列表
    getTableList() {
      this.loading = true
      return this.$api.clockIn
        .punchTemplate()
        .then((res) => {
          console.log(res)
          this.tableData = res
          if (res.length == 0) return (this.loading = false)
          this.tableData.forEach((item, index) => {
            const id = item.punchSettingId
            this.getCompanyList({ id }, index) // 账号管理ids接口
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // 账号管理ids接口
    getCompanyList(data, i) {
      this.$api.clockIn
        .getById(data)
        .then((res) => {
          console.log(res)
          this.enterpriseId = res.enterpriseId
          // let arr = Object.keys(res)
          // if (arr.length == 0) return (this.loading = false)
          this.tableData.map((item, index) => {
            if (i == index) {
              const obj = {
                company: res
              }
              Object.assign(item, obj)
            }
          })
          this.tableData2 = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData2)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 创建文件夹之前重名校验
    checkExistName(rule, value, callback) {
      console.log(value)
      value.map((item) => {
        if (!item.title) {
          return callback(new Error('请选择打卡地点'))
        } else {
          callback()
        }
      })
    },
    checkExistDate(rule, value, callback) {
      console.log(value)
      if (!value.punchTime1 && !value.punchTime2) {
        return callback(new Error('请填写打卡时间'))
      } else {
        callback()
      }
    },
    // 添加打卡地址
    AddSite() {
      this.form.locations.push({
        title: ''
      })
      this.siteLogLat.push({
        lon: '',
        lat: ''
      })
    },
    // 输入框选中时
    siteIFocus(index) {
      this.siteActive = index
      this.isshow = true
    },
    // 实时监听账号
    siteChangeI(title) {
      this.inputValue = title
    },
    // 删除打卡地点
    minusSite(index) {
      this.form.locations.splice(index, 1)
      this.siteLogLat.splice(index, 1)
    },
    // 点击地点图标判断哪个地点
    siteLocation(index) {
      this.siteActive = index
    },
    // 提交
    handleSubmit(isAdd) {
      console.log(isAdd)
      const locations = {}
      this.siteLogLat.forEach((item, i) => {
        const animals = { [`locations[${i}].lat`]: item.lat }
        const animals2 = { [`locations[${i}].lon`]: item.lon }
        Object.assign(locations, animals, animals2)
      })
      console.log(locations)
      if (!this.validateForm()) return
      console.log(this.tableData2, this.activeIndex)
      const params = isAdd
        ? {
          punchName: this.form.punchName,
          enterpriseId: this.enterpriseId,
          punchRange: Number(this.form.punchRange),
          punchTime1: this.form.dakaDate.punchTime1,
          punchTime2: this.form.dakaDate.punchTime2
        }
        : {
          id: this.Id,
          punchName: this.form.punchName,
          enterpriseId: this.enterpriseId,
          punchRange: Number(this.form.punchRange),
          punchTime1: this.form.dakaDate.punchTime1,
          punchTime2: this.form.dakaDate.punchTime2
        }
      const data = {}
      Object.assign(data, params, locations)
      console.log(data)
      if (isAdd) {
        this.loading = true
        this.$api.clockIn
          .saveDakaSite(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList() // 获取打卡模板列表
            // this.getVerifyCount()
            this.showDialog = false
          })
          .catch((e) => {
            this.$message.error(e)
          })
      } else {
        this.loading = true
        this.$api.clockIn
          .updateDakaSite(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
            // this.getVerifyCount()
            this.showDialog = false
          })
          .catch((e) => {
            this.$message.error(e)
          })
      }
    },
    // 添加/编辑
    openDialog(title, row) {
      this.form.poiAddress = ''
      this.form.poiCity = ''
      this.form.poiDistrict = ''
      this.form.poiProvince = ''
      this.dialogTitle = title
      this.showDialog = true
      this.form.punchName = ''
      this.form.punchRange = ''
      this.form.dakaDate.punchTime1 = ''
      this.form.dakaDate.punchTime2 = ''
      this.form.locations = [
        {
          title: ''
        }
      ]
      this.siteLogLat = [
        {
          lon: '',
          lat: ''
        }
      ]
      if (!row) return
      console.log(row, title)
      this.tableData2.map((item) => {
        if (item.punchSettingId == row.punchSettingId) {
          this.Id = item.company.id
        }
      })
      this.mapCenter = [113, 23]
      this.zoom = 12
      const { company } = row
      this.siteLogLat = company.locations
      company.locations.forEach((item, index) => {
        if (index > 0) {
          this.form.locations.push({
            title: ''
          })
        }
        this.getAddress(item.lon, item.lat, index + 1)
      })
      console.log(this.form.locations)
      this.form.punchName = company.punchName
      this.form.punchRange = company.punchRange
      this.form.dakaDate.punchTime1 = company.punchTime1
      this.form.dakaDate.punchTime2 = company.punchTime2
      // console.log(company)
      // this.inputValue = poiAddress
    },
    // 取消弹窗
    closeDialog() {
      this.showDialog = false
      this.form.punchName = ''
      this.form.punchRange = ''
      // this.form.dakaDate.punchTime1 = ''
      // this.form.dakaDate.punchTime2 = ''
      this.form.locations = [
        {
          title: ''
        }
      ]
      this.siteLogLat = [
        {
          lon: '',
          lat: ''
        }
      ]
      console.log(this.form.locations)
    },
    // 批量删除打卡地点
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项哦！')
      this.$api.clockIn
        .deleteDakaSite({ ids: this.ids.join(',') })
        .then((res) => {
          this.$message.success('操作成功')
          this.getTableList() // 获取打卡模板列表
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    // 批量选中
    handleSelectionChange(e) {
      console.log(e)
      this.ids = e.map((item) => item.punchSettingId)
      console.log(this.ids)
    },

    getVerifyCount() {
      this.authCount.loading = true
      return this.$api.company
        .reqCompanyCount()
        .then((res) => {
          this.authCount.count = res
          this.authCount.loading = false
        })
        .catch((e) => {
          this.authCount.loading = false
        })
    },
    getPendingList() {
      this.$refs.screenForm.resetFields()
      this.screenForm.auth = 0
      this.screenData()
    },

    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },

    handleDeleteCompany(row) {
      this.$confirm('此操作将永久删除该企业, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.company
            .reqDeleteCompany({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.loading = true
              this.getTableList()
              this.getVerifyCount()
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    beforeAvatarUpload(file) {
      const isImg = /image/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImg && isLt2M
    },
    // 这个是接口？、
    getAddress(lon, lat, index) {
      if (!index) {
        this.siteLogLat[this.siteActive] = {
          lon: lon,
          lat: lat
        }
      }
      console.log(index)
      if (this.gettingAddress) return
      if (index == this.siteLogLat.length) {
        this.gettingAddress = true
      }
      this.$api.common
        .reqGeocoder({ lat, lon })
        .then((res) => {
          console.log(res, 55656565)
          if (!index) {
            this.inputValue = res.address
          } else {
            this.form.locations[index - 1].title = res.address
          }
          this.form.poiAddress = res.address
          this.form.poiCity = res.city
          this.form.poiDistrict = res.district
          this.form.poiProvince = res.province
          this.gettingAddress = false
        })
        .catch(() => (this.gettingAddress = false))
        .finally(() => {
          if (
            this.form.poiAddress &&
            this.form.poiAddress !== '[]' &&
            this.form.poiCity &&
            this.form.poiCity !== '[]' &&
            this.form.poiDistrict &&
            this.form.poiDistrict !== '[]' &&
            this.form.poiProvince &&
            this.form.poiProvince !== '[]'
          ) {
            this.$refs.form.clearValidate('poiAddress')
          } else {
            this.$refs.form.validateField('poiAddress')
          }
        })
    },
    beforeImagesUpload(file) {
      const isImg = /image/.test(file.type)
      const isVideo = /video/.test(file.type)
      if (!isImg && !isVideo) {
        this.$message.error('只能上传图片或者视频')
      }
      return isImg || isVideo
    },
    handleBusinessLicenseSuccess(res) {
      this.$refs.form.clearValidate('businessLicense')
      this.form.businessLicense = res.data
    },
    handleLogoSuccess(res) {
      this.$refs.form.clearValidate('logo')
      this.form.logo = res.data
    },
    handleIntroduceSuccess(res, file, filelist) {
      console.log(res, file, filelist)
      file.url = res.data
      this.form.introduceImages = [...this.form.introduceImages, file]
      this.$refs.form.clearValidate('introduceImages')
    },
    handleFuliSuccess(res, file) {
      file.url = res.data
      this.form.fuliImages = [...this.form.fuliImages, file]
      this.$refs.form.clearValidate('fuliImages')
    },
    handleJiyuSuccess(res, file) {
      file.url = res.data
      this.form.jiyuImages = [...this.form.jiyuImages, file]
      this.$refs.form.clearValidate('jiyuImages')
      console.log(file)
    },
    handleIntroduceRemove(file) {
      this.form.introduceImages = this.form.introduceImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('introduceImages')
    },
    handleFuliRemove(file) {
      console.log(this.form.fuliImages)
      this.form.fuliImages = this.form.fuliImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('fuliImages')
    },
    handleJiyuRemove(file) {
      this.form.jiyuImages = this.form.jiyuImages.filter((item) => item.url !== file.url)
      this.form.jiyuImages.length || this.$refs.form.validateField('jiyuImages')
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    refresh() {
      // this.getTableList() // 获取打卡模板列表
      // this.tableH = this.$refs.tableWrap.clientHeight
      // this.page = {
      //   pageNumber: 1,
      //   pageSize: 10
      // }
      // this.$refs.screenForm.resetFields()
      Promise.all([this.reqCompanyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    reqCompanyCount() {
      this.authCount.loading = true
      return this.$api.company
        .reqCompanyCount()
        .then((res) => {
          this.authCount.count = res
          this.authCount.loading = false
        })
        .catch((e) => {
          this.authCount.loading = false
        })
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getVerifyCount(), this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    isImage(url) {
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let format = url.split('.')
      format = format[format.length - 1]
      if (imglist.some((item) => item === format)) {
        return true
      } else {
        return false
      }
    },
    previewVideo(url) {
      this.videoUrl = url
      this.previewVideoDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.area {
  width: max-content;
  padding: 0 10px;
  margin: 0 5px;
  border-radius: 10rpx;
  background-color: #f2f2f2;
  color: #666;
  margin-bottom: 15px;
}
/*地图类*/
.amap-demo {
  width: 100%;
  height: 600px;
  position: relative;
}

.search-box {
  height: 35px;
  margin: 10px auto;
  width: calc(100% - 20px);
  // border-radius:16px;
  box-shadow: none;
  background: #ffff;
  border: 1px solid #e6e6e6;

  .search-box-wrapper {
    input {
      background: #fff;
      padding-left: 20px;
    }

    .search-btn {
      color: #2a67fe;
      width: 90px;
      height: 20px;
      box-sizing: border-box;
      border-left: 1px solid #d7d7d7;
    }
  }
}
</style>
